/**
 * @generated SignedSource<<64cec4a2c19262792e26415b412ef0d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselItemTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ItemHeartWrapper_viewer" | "ItemTile_viewer">;
  readonly " $fragmentType": "CarouselItemTile_viewer";
};
export type CarouselItemTile_viewer$key = {
  readonly " $data"?: CarouselItemTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselItemTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchFavorites"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselItemTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemTile_viewer"
    },
    {
      "condition": "fetchFavorites",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "loadPortfolioData",
              "variableName": "fetchFavorites"
            },
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "userIds.0",
                  "variableName": "userId"
                }
              ],
              "kind": "ListValue",
              "name": "userIds"
            }
          ],
          "kind": "FragmentSpread",
          "name": "ItemHeartWrapper_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6af9a4a3d7f5c12a0840028289d25071";

export default node;
